export type LanguageId = string;

const LANGUAGE_ALIASES: Record<string, LanguageId> = {
  typescript: "typescript",
  ts: "typescript",
  tsx: "tsx",
  javascript: "javascript",
  js: "javascript",
  jsx: "jsx",
  json: "json",
  jsonc: "jsonc",
  json5: "json5",
  yaml: "yaml",
  yml: "yaml",
  markdown: "markdown",
  md: "markdown",
  bash: "bash",
  sh: "bash",
  shell: "bash",
  zsh: "bash",
  shellscript: "shellscript",
  powershell: "powershell",
  ps: "powershell",
  ps1: "powershell",
  psm1: "powershell",
  python: "python",
  py: "python",
  ruby: "ruby",
  rb: "ruby",
  go: "go",
  rust: "rust",
  rs: "rust",
  java: "java",
  kotlin: "kotlin",
  kt: "kotlin",
  kts: "kotlin",
  swift: "swift",
  c: "c",
  h: "c",
  cpp: "cpp",
  cc: "cpp",
  cxx: "cpp",
  hpp: "cpp",
  csharp: "csharp",
  cs: "csharp",
  csproj: "xml",
  php: "php",
  sql: "sql",
  graphql: "graphql",
  gql: "graphql",
  css: "css",
  scss: "scss",
  sass: "sass",
  less: "less",
  html: "html",
  xml: "xml",
  vue: "vue",
  svelte: "svelte",
  docker: "docker",
  dockerfile: "docker",
  protobuf: "proto",
  proto: "proto",
  ini: "ini",
  cfg: "ini",
  env: "bash",
  toml: "toml",
  diff: "diff",
  makefile: "makefile",
  make: "makefile",
  glsl: "glsl",
  jsonl: "jsonl",
};

const LANGUAGE_LABELS: Record<string, string> = {
  typescript: "TypeScript",
  tsx: "TSX",
  javascript: "JavaScript",
  jsx: "JSX",
  json: "JSON",
  jsonc: "JSONC",
  json5: "JSON5",
  yaml: "YAML",
  markdown: "Markdown",
  bash: "Bash",
  shellscript: "Shell",
  powershell: "PowerShell",
  python: "Python",
  ruby: "Ruby",
  go: "Go",
  rust: "Rust",
  java: "Java",
  kotlin: "Kotlin",
  swift: "Swift",
  c: "C",
  cpp: "C++",
  csharp: "C#",
  php: "PHP",
  sql: "SQL",
  graphql: "GraphQL",
  css: "CSS",
  scss: "SCSS",
  sass: "Sass",
  less: "Less",
  html: "HTML",
  xml: "XML",
  vue: "Vue",
  svelte: "Svelte",
  docker: "Dockerfile",
  proto: "Protocol Buffers",
  ini: "INI",
  toml: "TOML",
  diff: "Diff",
  makefile: "Makefile",
  glsl: "GLSL",
};

export function resolveLanguageId(input?: string): LanguageId | undefined {
  if (!input) {
    return undefined;
  }

  const normalized = input.toLowerCase();
  return LANGUAGE_ALIASES[normalized];
}

export function getLanguageDisplayName(input?: string): string {
  if (!input) {
    return "TEXT";
  }

  const normalized = input.toLowerCase();
  const canonical = LANGUAGE_ALIASES[normalized] ?? normalized;
  const label = LANGUAGE_LABELS[canonical] ?? LANGUAGE_LABELS[normalized] ?? canonical;
  return label.toUpperCase();
}
